
import * as React from 'react';
import { downloadItemsActionControlFacet, IDownloaderProps } from '../../../../controls/downloadItemsActionControl';
import {
  withSelectedItems,
  withCurrentItemAsFallback,
  IDecorateWithSelectedItemsProps,
  IDecorateWithCurrentItemAsFallbackProps
} from '../../../decorators/selectors';
import { WithItemCache, IItemCacheStateProps } from '../../../withItemCache/WithItemCache';
import { IWizardActionStateProps, HeadlessAction } from '../../../wizardAction/WizardAction';
import { getItemActionEngagement } from '../../../../models/telemetry/getItemEngagement';
import { ItemsScope } from '../../../itemsScope/ItemsScope';
import { getItemsScope } from '../../../decorators/connectToItemsScope';

export interface IItemDownloadActionProps {
  itemKeys: string[];
  downloader: React.ComponentType<IDownloaderProps>;
}

export class ItemDownloadAction extends React.PureComponent<IItemDownloadActionProps> {
  public render(): JSX.Element {
    const {
      itemKeys,
      downloader
    } = this.props;

    return (
      <WithItemCache>
        { ({ itemCache, dispatch }: IItemCacheStateProps) => {
          const [itemKey] = itemKeys;

          if (!itemKey) {
            return (
              <HeadlessAction isAvailable={ false } />
            );
          }

          const { itemsScopeItemKey } = getItemsScope(itemCache);

          const controlHandler = itemCache.demandItemFacet(downloadItemsActionControlFacet, itemKey);

          const {
            downloader: Downloader,
            getDownloadData: getDownloadDataCreator,
            isAvailable
          } = downloadItemsActionControlFacet.evaluate(controlHandler)(itemCache, { // tslint:disable-line:max-line-length
            itemKeys: itemKeys,
            downloader: downloader,
            isAvailable: false
          });

          if (!Downloader || !getDownloadDataCreator || !isAvailable) {
            return (
              <HeadlessAction isAvailable={ false } />
            );
          }

          const getDownloadData = () => dispatch(getDownloadDataCreator());

          return (
            <HeadlessAction
              isAvailable={ isAvailable }
              { ...getItemActionEngagement(itemCache, {
                itemKey,
                engagement: {
                  name: 'Download',
                  isIntentional: true
                }
              }) }
            >
              { (wizardProps: IWizardActionStateProps) => {
                return (
                  // In case the background action needs the current itemsScopeItemKey,
                  // wrap the downloader with an ItemsScope pointed at the same state.
                  <ItemsScope itemsScopeItemKey={ itemsScopeItemKey }>
                    <Downloader
                      itemKeys={ itemKeys }
                      getDownloadData={ getDownloadData }
                      { ...wizardProps }
                    />
                  </ItemsScope>
                );
              } }
            </HeadlessAction>
          );
        } }
      </WithItemCache>
    );
  }
}

export type IDownloadActionProps = IDecorateWithSelectedItemsProps<IDecorateWithCurrentItemAsFallbackProps<IItemDownloadActionProps>>;

export const DownloadAction: React.ComponentType<IDownloadActionProps> =
  withSelectedItems()(withCurrentItemAsFallback()(ItemDownloadAction));
